import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { BottomSheetBackdrop, BottomSheetSheet } from "sprout-ui-dom/dist/BottomSheet";
import { Button, Editor as BaseEditor, useEditorRef } from "sprout-ui-dom";
import { Flex } from "sprout-ui-primitives";
import styled from "styled-components";
import { Form } from "sprout-ui-dom/dist/Form";
const Editor = styled(BaseEditor)`
  .ProseMirror {
    font-size: 20px;
    padding: 24px 16px;
  }
`;
const TopicPageEditorPostMobile = (props)=>{
    const { topicId , closeEditor , onEscape , onEnter , onSave , initialState  } = props;
    const editorRef = useEditorRef();
    const handleSubmit = useCallback(()=>{
        if (editorRef.current) onEnter(editorRef.current);
    }, [
        editorRef,
        onEnter
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BottomSheetBackdrop, {
                onClick: closeEditor
            }),
            /*#__PURE__*/ _jsxs(BottomSheetSheet, {
                as: Form,
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ _jsx(Editor, {
                        initialState: initialState,
                        itemId: topicId,
                        mode: "BASIC",
                        placeholder: "What\u2019s on your mind?",
                        autoFocus: "end",
                        onEscape: onEscape,
                        onEnter: onEnter,
                        onSave: onSave,
                        ref: editorRef,
                        ensureWithinViewport: false
                    }),
                    /*#__PURE__*/ _jsx(Flex, {
                        justifyContent: "flex-end",
                        pb: 3,
                        px: 3,
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "bright-blue",
                            type: "submit",
                            children: initialState ? "Save changes" : "Save"
                        })
                    })
                ]
            })
        ]
    });
};
export default TopicPageEditorPostMobile;
